"use client";

import { c as _c } from "react/compiler-runtime";
import CreateWaveInlineGroupActions from "./CreateWaveInlineGroupActions";
import CreateWaveInlineGroupDraftSummary from "./CreateWaveInlineGroupDraftSummary";
import CreateWaveInlineGroupExpandedPanel from "./CreateWaveInlineGroupExpandedPanel";
import CreateWaveInlineGroupHeader from "./CreateWaveInlineGroupHeader";
import CreateWaveInlineGroupIdentities from "./CreateWaveInlineGroupIdentities";
import CreateWaveInlineGroupRuleEditor from "./CreateWaveInlineGroupRuleEditor";
import { CreateWaveInlineGroupRuleEditorPanel, CreateWaveInlineGroupRuleList } from "./CreateWaveInlineGroupRules";
import CreateWaveInlineGroupSearch from "./CreateWaveInlineGroupSearch";
import { type CreateWaveGroupInlinePanelProps, useCreateWaveGroupInlinePanel } from "./useCreateWaveGroupInlinePanel";
export default function CreateWaveGroupInlinePanel(props) {
  const $ = _c(70);
  const {
    allowGroupClear: t0,
    defaultLabel,
    disabled: t1,
    selectedGroup
  } = props;
  const allowGroupClear = t0 === undefined ? true : t0;
  const disabled = t1 === undefined ? false : t1;
  const {
    addIdentity,
    canCreateDraft,
    canResetDraft,
    currentGroupLabel,
    displayedBuilder,
    draftSummary,
    hasUnsavedGroup,
    isCreating,
    isDraftValid,
    isExpandedPanel,
    isIdentityPanel,
    isRulePanel,
    isSearchPanel,
    onCancelPanel,
    onClearAll,
    onCreateAndUse,
    onExistingGroupSelect,
    openRule,
    panelRef,
    removeIdentity,
    setDraft,
    showDraftFooter,
    togglePanel,
    toggleRule,
    unsavedGroupDescription,
    unsavedGroupSummary
  } = useCreateWaveGroupInlinePanel(props);
  const t2 = `tw-relative tw-flex tw-flex-col tw-gap-5 tw-rounded-xl tw-border tw-border-solid tw-p-5 tw-transition-all tw-duration-300 ${isExpandedPanel ? "tw-border-white/10 tw-bg-iron-900 tw-shadow-2xl" : "tw-border-white/5 tw-bg-iron-900/60 tw-shadow-inner"}`;
  let t3;
  if ($[0] !== currentGroupLabel || $[1] !== unsavedGroupDescription || $[2] !== unsavedGroupSummary) {
    t3 = <CreateWaveInlineGroupHeader currentGroupLabel={currentGroupLabel} unsavedGroupDescription={unsavedGroupDescription} unsavedGroupSummary={unsavedGroupSummary} />;
    $[0] = currentGroupLabel;
    $[1] = unsavedGroupDescription;
    $[2] = unsavedGroupSummary;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isIdentityPanel || $[5] !== togglePanel) {
    t4 = () => togglePanel("identity", isIdentityPanel);
    $[4] = isIdentityPanel;
    $[5] = togglePanel;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== isRulePanel || $[8] !== togglePanel) {
    t5 = () => togglePanel("rule-list", isRulePanel);
    $[7] = isRulePanel;
    $[8] = togglePanel;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== isSearchPanel || $[11] !== togglePanel) {
    t6 = () => togglePanel("search", isSearchPanel);
    $[10] = isSearchPanel;
    $[11] = togglePanel;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== disabled || $[14] !== isIdentityPanel || $[15] !== isRulePanel || $[16] !== isSearchPanel || $[17] !== t4 || $[18] !== t5 || $[19] !== t6) {
    t7 = <CreateWaveInlineGroupActions disabled={disabled} identityActive={isIdentityPanel} ruleActive={isRulePanel} searchActive={isSearchPanel} onAddIdentity={t4} onAddRule={t5} onUseExistingGroup={t6} />;
    $[13] = disabled;
    $[14] = isIdentityPanel;
    $[15] = isRulePanel;
    $[16] = isSearchPanel;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== addIdentity || $[22] !== displayedBuilder.identities || $[23] !== displayedBuilder.panel || $[24] !== onCancelPanel || $[25] !== removeIdentity) {
    t8 = displayedBuilder.panel === "identity" && <CreateWaveInlineGroupExpandedPanel onCancel={onCancelPanel} cancelClassName="tw-mt-3"><CreateWaveInlineGroupIdentities identities={displayedBuilder.identities} onIdentitySelect={addIdentity} onRemove={removeIdentity} /></CreateWaveInlineGroupExpandedPanel>;
    $[21] = addIdentity;
    $[22] = displayedBuilder.identities;
    $[23] = displayedBuilder.panel;
    $[24] = onCancelPanel;
    $[25] = removeIdentity;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== disabled || $[28] !== displayedBuilder.panel || $[29] !== onCancelPanel || $[30] !== openRule) {
    t9 = displayedBuilder.panel === "rule-list" && <CreateWaveInlineGroupExpandedPanel onCancel={onCancelPanel}><CreateWaveInlineGroupRuleList disabled={disabled} onRuleOpen={openRule} /></CreateWaveInlineGroupExpandedPanel>;
    $[27] = disabled;
    $[28] = displayedBuilder.panel;
    $[29] = onCancelPanel;
    $[30] = openRule;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  let t10;
  if ($[32] !== disabled || $[33] !== displayedBuilder.activeRule || $[34] !== displayedBuilder.draft || $[35] !== displayedBuilder.panel || $[36] !== onCancelPanel || $[37] !== setDraft || $[38] !== toggleRule) {
    t10 = displayedBuilder.panel === "rule-editor" && displayedBuilder.activeRule !== null && <CreateWaveInlineGroupExpandedPanel onCancel={onCancelPanel}><CreateWaveInlineGroupRuleEditorPanel activeRule={displayedBuilder.activeRule} disabled={disabled} onRuleToggle={toggleRule}><CreateWaveInlineGroupRuleEditor draft={displayedBuilder.draft} activeRule={displayedBuilder.activeRule} onDraftChange={setDraft} /></CreateWaveInlineGroupRuleEditorPanel></CreateWaveInlineGroupExpandedPanel>;
    $[32] = disabled;
    $[33] = displayedBuilder.activeRule;
    $[34] = displayedBuilder.draft;
    $[35] = displayedBuilder.panel;
    $[36] = onCancelPanel;
    $[37] = setDraft;
    $[38] = toggleRule;
    $[39] = t10;
  } else {
    t10 = $[39];
  }
  let t11;
  if ($[40] !== allowGroupClear || $[41] !== defaultLabel || $[42] !== disabled || $[43] !== displayedBuilder.panel || $[44] !== hasUnsavedGroup || $[45] !== onCancelPanel || $[46] !== onExistingGroupSelect || $[47] !== selectedGroup) {
    t11 = displayedBuilder.panel === "search" && <CreateWaveInlineGroupExpandedPanel onCancel={onCancelPanel} cancelClassName="tw-mt-3"><CreateWaveInlineGroupSearch defaultLabel={defaultLabel} disabled={disabled} hasUnsavedGroup={hasUnsavedGroup} selectedGroup={selectedGroup} allowGroupClear={allowGroupClear} onSelect={onExistingGroupSelect} /></CreateWaveInlineGroupExpandedPanel>;
    $[40] = allowGroupClear;
    $[41] = defaultLabel;
    $[42] = disabled;
    $[43] = displayedBuilder.panel;
    $[44] = hasUnsavedGroup;
    $[45] = onCancelPanel;
    $[46] = onExistingGroupSelect;
    $[47] = selectedGroup;
    $[48] = t11;
  } else {
    t11 = $[48];
  }
  let t12;
  if ($[49] !== canCreateDraft || $[50] !== canResetDraft || $[51] !== draftSummary || $[52] !== isCreating || $[53] !== isDraftValid || $[54] !== onClearAll || $[55] !== onCreateAndUse || $[56] !== showDraftFooter) {
    t12 = showDraftFooter && <CreateWaveInlineGroupDraftSummary draftSummary={draftSummary} isValid={isDraftValid} canResetDraft={canResetDraft} canCreateDraft={canCreateDraft} isCreating={isCreating} onClearAll={onClearAll} onCreateAndUse={onCreateAndUse} />;
    $[49] = canCreateDraft;
    $[50] = canResetDraft;
    $[51] = draftSummary;
    $[52] = isCreating;
    $[53] = isDraftValid;
    $[54] = onClearAll;
    $[55] = onCreateAndUse;
    $[56] = showDraftFooter;
    $[57] = t12;
  } else {
    t12 = $[57];
  }
  let t13;
  if ($[58] !== t10 || $[59] !== t11 || $[60] !== t12 || $[61] !== t3 || $[62] !== t7 || $[63] !== t8 || $[64] !== t9) {
    t13 = <div className="tw-relative tw-flex tw-flex-col tw-gap-5">{t3}{t7}{t8}{t9}{t10}{t11}{t12}</div>;
    $[58] = t10;
    $[59] = t11;
    $[60] = t12;
    $[61] = t3;
    $[62] = t7;
    $[63] = t8;
    $[64] = t9;
    $[65] = t13;
  } else {
    t13 = $[65];
  }
  let t14;
  if ($[66] !== panelRef || $[67] !== t13 || $[68] !== t2) {
    t14 = <div ref={panelRef} className={t2}>{t13}</div>;
    $[66] = panelRef;
    $[67] = t13;
    $[68] = t2;
    $[69] = t14;
  } else {
    t14 = $[69];
  }
  return t14;
}